module.exports = __webpack_public_path__ + "img/panelView_strong_2_3.15c5baa4.png";